import { useEffect, useState } from "react";
import { useUser } from "src/shared/context/UserContext";

export function useBusinessSettings() {
  const [businessType, setBusinessType] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [isEmployee, setIsEmployee] = useState(false);
  const [loading, setLoading] = useState(false);
  const { user } = useUser();

  useEffect(() => {
    setLoading(true);

    const business = user?.orgName ?? "";
    const businessType = user?.businessType ?? "";
    const storedColor = (`user?.themes.backgroundColour${business}`);
    const employeeLogin = sessionStorage.getItem("employee");

    setOrganizationName(business);
    setBusinessType(businessType);
    setIsEmployee(!!employeeLogin);

    if (storedColor) {
      document.documentElement.style.setProperty("--color", storedColor);
    }

    const fontFamily = sessionStorage.getItem(`font_family${business}`);
    if (fontFamily) {
      document.documentElement.style.setProperty("--fontfamily", fontFamily);
    }

    setLoading(false);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { businessType, organizationName, isEmployee, loading };
}


